<app-navbar title="Kierowcy">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-drivers-list-filters
	userFilters="drivers"
	[statuses]="parameters.statuses"
	[driverKinds]="parameters.driverKinds"
	[yesno]="parameters.yesno"
	(selected)="filtersSelected($event)"
></app-drivers-list-filters>

<app-dynamic-table
	module="drivers"
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
